export default {
    token: localStorage.getItem('token') || '',
    userRole: 'default',
    status: '',
    auth_user: {},
    locale: 'en',
    country: '',
    additionalTranslations: [],
    emailConfirmed: null
};